/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Ui_SubmittedInputs */

const en_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted — sending to AI...`)
};

const ar_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الإرسال، جارٍ الإرسال إلى الذكاء الاصطناعي...`)
};

const bn_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাবমিট হয়েছে, AI-তে পাঠানো হচ্ছে...`)
};

const de_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht – an AI gesendet...`)
};

const es_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado: enviando a AI...`)
};

const fr_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumis, envoi à l'IA...`)
};

const pt_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado, enviando para AI...`)
};

const zh_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提交，发送至 AI...`)
};

const tr_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderildi, AI'ye gönderiliyor...`)
};

const ru_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлено, отправка в AI...`)
};

const pl_dynamic_ui_submitted = /** @type {(inputs: Dynamic_Ui_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłano, wysyłanie do AI...`)
};

/**
* | output |
* | --- |
* | "Submitted — sending to AI..." |
*
* @param {Dynamic_Ui_SubmittedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dynamic_ui_submitted = /** @type {((inputs?: Dynamic_Ui_SubmittedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Ui_SubmittedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dynamic_ui_submitted(inputs)
	if (locale === "bn") return bn_dynamic_ui_submitted(inputs)
	if (locale === "de") return de_dynamic_ui_submitted(inputs)
	if (locale === "es") return es_dynamic_ui_submitted(inputs)
	if (locale === "fr") return fr_dynamic_ui_submitted(inputs)
	if (locale === "pt") return pt_dynamic_ui_submitted(inputs)
	if (locale === "zh") return zh_dynamic_ui_submitted(inputs)
	if (locale === "tr") return tr_dynamic_ui_submitted(inputs)
	if (locale === "ru") return ru_dynamic_ui_submitted(inputs)
	if (locale === "pl") return pl_dynamic_ui_submitted(inputs)
	return en_dynamic_ui_submitted(inputs)
});